module.exports = __webpack_public_path__ + "assets/img/icon-marker-building.661bfc53.png";